var map = {
	"./en": [
		6443
	],
	"./en.json": [
		6443
	],
	"./zh-hans": [
		3673,
		649
	],
	"./zh-hans.json": [
		3673,
		649
	],
	"./zh-hant": [
		7568,
		470
	],
	"./zh-hant.json": [
		7568,
		470
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6283;
module.exports = webpackAsyncContext;